import React from 'react';
import PropTypes from 'prop-types';
import { cardProviders } from '../../../../../screens/Card/constants';
import { useUserCardProvider } from '../../../../../utilities/sharedHooks/user';

const POSITIONS = {
  [cardProviders.MONAVATE]: {
    x: 15,
    y: 125,
    fontSize: 16,
    fontWeight: '500',
  },
};

export function CardHolderDisplayName({ displayName = '' }) {
  const { cardProvider } = useUserCardProvider();
  const { x = 15, y = 200, fontWeight = 'bold', fontSize = 16 } = POSITIONS[cardProvider] || {};
  return (
    <g>
      <text fill="#191919" fontWeight={fontWeight} fontSize={fontSize} x={x} y={y}>
        {displayName}
      </text>
    </g>
  );
}
CardHolderDisplayName.propTypes = {
  displayName: PropTypes.string,
};
export default CardHolderDisplayName;
